import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Llegando a la consulta sin saber exactamente qué planta nativa prescribir para el cuadro que tenés enfrente.', 'Dudando entre varias hierbas porque no tenés una ficha técnica clara que te respalde.', 'Sin saber qué preparación hacer con esa planta — infusión, tintura, pomada o decocción.', 'Sin conocer las contraindicaciones exactas antes de recomendar a una paciente embarazada o medicada.', 'Sin protocolo de seguridad ante interacciones planta-fármaco.', 'Sin recetario de fórmulas concretas — armando cada combinación desde cero en cada consulta.', 'Sin ficha clínica profesional — cada consulta sin registro ni continuidad.', 'Sin saber de dónde proviene tu materia prima ni cómo evaluarla.', 'Pacientes que no vuelven porque no perciben resultados concretos.', 'Cada sesión comenzás de cero, sin estructura real ni respaldo clínico.'];
  return <Section className="max-w-4xl" data-id="element-374">
      <div className="text-center mb-12" data-id="element-375">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-purpleDark" data-id="element-376">
          ¿Cuántas consultas más vas a trabajar sin un sistema clínico sólido?
        </h2>
        <p className="text-brand-text mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-377">
          Sos terapeuta natural. Amás lo que hacés. Creés en el poder de las
          plantas nativas de esta tierra. Pero nadie te dijo que ibas a llegar a
          la consulta sin saber exactamente qué planta prescribir, en qué dosis,
          con qué precauciones y para qué cuadro específico.
        </p>

        <p className="text-lg md:text-xl font-medium text-brand-burgundy mt-6 font-serif italic" data-id="element-378">
          No es falta de vocación. No es falta de experiencia. Es falta de un
          sistema.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-purple/20" data-id="element-379">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-purpleDark text-base md:text-lg" data-id="element-380">
          <X className="w-6 h-6 text-brand-burgundy mr-2 shrink-0" data-id="element-381" /> Lo que
          pasa sin el Kit Saberes Ancestrales Argentinos:
        </h3>
        <ul className="space-y-4" data-id="element-382">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-383">
              <X className="w-5 h-5 text-brand-burgundy/80 mr-3 mt-0.5 shrink-0" data-id="element-384" />
              <span className="text-brand-text text-sm md:text-base" data-id="element-385">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-386">
        <h3 className="text-xl md:text-3xl font-display font-bold purple-gradient-text" data-id="element-387">
          ¿Y si esta fuera la última consulta que trabajás así?
        </h3>
      </div>
    </Section>;
};